<template>
  <div>
    <div class="form-section-base__controls">
      <v-radio-group v-model="fillType" row>
        <v-radio
          v-if="isTrusteeRadioVisible"
          :label="labelTrusteeManual"
          :value="SubjectFillType.MANUAL"
        />
        <v-radio
          v-if="isMachineRadioVisible"
          :label="SubjectFillTypeText.MACHINE"
          :value="SubjectFillType.MACHINE"
        />
        <v-radio
          v-if="isAssigneeRadioVisible"
          :label="labelAssigneeManual"
          :value="SubjectFillType.ASSIGNEE"
        />
      </v-radio-group>
    </div>

    <template v-if="isManualVisible">
      <EgrnTrustee
        v-if="isEgrn"
        :role="role"
        :trustee-info="trusteeInfo"
        :assignee="assignee"
        :fill-type="fillType"
        @send="$emit('send', $event)"
      >
        <template #footer="{ next }">
          <slot name="footer" :next="next"></slot>
        </template>
      </EgrnTrustee>
      <DefaultTrustee
        v-else
        :role="role"
        :add-statement="addStatement"
        @send="$emit('send', $event)"
      >
        <template #footer="{ next }">
          <slot name="footer" :next="next"></slot>
        </template>
      </DefaultTrustee>
    </template>

    <AddStMrpaTrustee
      v-if="fillType === SubjectFillType.MACHINE"
      :role="role"
      :original-statement-id="addStatement.originalStatementId"
      :original-statement-type="addStatement.originalStatementType"
      @send="$emit('send', $event)"
    >
      <template #footer="{ next }">
        <slot name="footer" :next="next"></slot>
      </template>
    </AddStMrpaTrustee>
  </div>
</template>

<script>
import { SubjectFillType, SubjectFillTypeText, SubjectType } from '@/constants';
import { FieldGroup } from '@/utils/fullStatementView';
import { Role } from '@/utils/dictionaries';
import { StatementType } from '@/types/services';
import EgrnTrustee from './EgrnTrustee/EgrnTrustee';
import DefaultTrustee from './DefaultTrustee';
import AddStMrpaTrustee from '../AddStMrpaTrustee';
import { isMrpaEnable } from '@/app.config';
import { getSubjectTitle } from '@/utils/common';

export default {
  name: 'ManualTrustee',
  components: {
    EgrnTrustee,
    DefaultTrustee,
    AddStMrpaTrustee,
  },
  props: {
    addStatement: {
      type: Object,
      required: true,
    },
    role: {
      type: String,
      required: true,
    },
    trusteeInfo: {
      type: Object,
    },
    assignee: {
      type: Object,
    },
    fillTypeProp: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    Role,
    SubjectFillType,
    SubjectFillTypeText,
    FieldGroup,
    fillType: SubjectFillType.MANUAL,
  }),
  computed: {
    isEgrn() {
      return this.addStatementStatementType === StatementType.EGRN_CONFIRM;
    },

    addStatementStatementType() {
      return this.addStatement.originalStatementType;
    },

    isManualVisible() {
      return [SubjectFillType.MANUAL, SubjectFillType.ASSIGNEE].includes(
        this.fillType
      );
    },

    labelTrusteeManual() {
      return getSubjectTitle({
        statementType: this.addStatementStatementType,
        role: this.role,
        subjectType: SubjectType.APPLICANT,
      });
    },

    labelAssigneeManual() {
      return getSubjectTitle({
        statementType: this.addStatementStatementType,
        role: this.role,
        subjectType: SubjectType.ASSIGNEE,
      });
    },

    isAssigneeRadioVisible() {
      const isAssigneeStatement = [
        StatementType.EGRN_CONFIRM,
      ].includes(this.addStatementStatementType);

      if (!this.isPerson && isAssigneeStatement) return true;

      return Boolean(this.assignee);
    },

    isPerson() {
      return this.role === Role.PERSON;
    },

    isMachineRadioVisible() {
      if (!isMrpaEnable(this.addStatementStatementType)) return false;

      if (!this.isPerson) return true;

      return Boolean(this.trusteeInfo);
    },

    isTrusteeRadioVisible() {
      const isExtractionRodStatement =
        this.addStatementStatementType === StatementType.EXTRACTION_ROD;

      if (!this.isPerson && !isExtractionRodStatement) return true;

      return Boolean(this.trusteeInfo);
    },
  },
  created() {
    this.prefillDraft();
  },
  methods: {
    prefillDraft() {
      this.fillType = this.fillTypeProp;
    },
  },
};
</script>
